<a
  class="cherry-box"
  (click)="onOpenModalCherryMeter()">
  <figure>
    <img
      alt="ciliegia"
      height="80"
      width="80"
      src="https://media.sharry.land/app/images/ciliegiometro/ciliegiometro-animated.svg?n={{ math.random() }}" />
    <figcaption>
      <h5 class="semibold baloo">
        {{ 'cherry-box.title' + (myCherries ? '--my-cherries' : '') | i18next }}<br /><span sharryEllipsisTooltip="1">{{
          (!!myCherries ? '' : 'cherry-box.title--value') | i18next: { value: __typename === 'User' ? username : _type }
        }}</span>
      </h5>
      <div>
        @for (box of [1, 2, 3, 4, 5]; track box) {
          <div class="cherry-box__number">
            <span
              class="cherry-box__number__digit"
              [ngClass]="'animate-number-' + box + '-' + _cherries[box - 1]"
              [attr.data-content]="'0123456789' | repeat: box - 1"></span>
          </div>
        }
      </div>
    </figcaption>
  </figure>
</a>
